import { render, staticRenderFns } from "./AddEditSws.vue?vue&type=template&id=39b76bff"
import script from "./AddEditSws.vue?vue&type=script&lang=js"
export * from "./AddEditSws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports